export default defineAppConfig({
    meta: {
        title: '人工智能商城平台',
        keywords: ["人工智能商城平台", "人工智能", "AI", "人工智能商城", "AI商城"],
        description: '人工智能商城平台是一种基于人工智能(AI)技术的电子商务解决方案。为响应2024年第十四届全国人民代表大会“人工智能+”发展创新号召，人工智能商城将先进的人工智能算法与商城运营、管理、营销、服务等各个环节紧密结合，为商家和消费者提供了更为高效、智能的购物体验。'
    },
    websiteName: '人工智能商城平台',
    productName: '人工智能商城'
})
